import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { fetchCustomers, fetchCustomerDetail } from '../../actions/customers_actions';
import { editSICustomer, resetEditSICustomer } from '../../actions/salesInvoice_actions';
import EditCustomerModal from '../../components/Sales/EditCustomerModal';

const validate = (values) => {
  const errors = {};
  if (!values.Deliver_Customer_id) {
    errors.Deliver_Customer_id = 'Required';
  }
  return errors;
};

const customerModal = reduxForm({
  form: 'editCustomerModal',
  validate,
})(EditCustomerModal);
const selector = formValueSelector('editCustomerModal');

function mapStateToProps(state) {
  const deliverCustomerId = selector(state, 'Deliver_Customer_id');
  return {
    deliverCustomerId,

    customers: state.customers.all,
    customersIsLoading: state.customers.isLoading,
    customersError: state.customers.error,
    currentCustomerDetail: state.customers.currentCustomerDetail,
    detailIsLoading: state.customers.detailIsLoading,
    detailError: state.customers.detailError,
    userPermissions: state.auth.userPermissions,
    siCustomerIsEditing: state.salesInvoice.siCustomerIsEditing,
    siCustomerEdited: state.salesInvoice.siCustomerEdited,
  };
}

export default connect(mapStateToProps, {
  editSICustomer,
  fetchCustomerDetail,
  fetchCustomers,
  resetEditSICustomer,
})(customerModal);



// WEBPACK FOOTER //
// ./master/jsx/containers/Sales/EditCustomerModal.jsx